import habitat from 'preact-habitat';

import News   from './components/news';
import Medals from './components/medals';

let news_habitat = habitat( News );
let medals_habitat = habitat( Medals );

news_habitat.render( {
	selector     : '[data-widget-id="olympics-news"]',
	defaultProps : {},
	clean        : true
} );

medals_habitat.render( {
	selector     : '[data-widget-id="olympics-medals"]',
	defaultProps : {
		displayCount : 5,
		sortBy       : 'Total',
		title        : 'Olympic Medals Race',
	},
	clean        : true
} );
